import { render } from "./NotContractedIc.vue?vue&type=template&id=c83dc42c&scoped=true&ts=true"
import script from "./NotContractedIc.vue?vue&type=script&lang=ts"
export * from "./NotContractedIc.vue?vue&type=script&lang=ts"

import "./NotContractedIc.vue?vue&type=style&index=0&id=c83dc42c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83dc42c"]])

export default __exports__